import _ from 'lodash'
import { Component, Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { required } from 'redux-form-validators'
import classNames from 'classnames'
import {
  getAllowedShipTypesBySubStationAndUser,
  getUIShipTypeOptions,
  checkSuppilerIncludedPreOrder
} from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import {
  EXPIRING_NOTE,
  PRODUCT_CONTENT_RATING,
  PRODUCT_DELIVERY_TYPE,
  PRODUCT_SHIP_TYPE,
  FIELD_MAX_LENGTH,
  SPECIAL_FUNCTION,
  PROPOSAL_PHASE_TYPE,
  IS_NEED_RECYCLE_TEXT
} from '@vzmi/shp_shared_compo/constants/proposal'
import styles from './index.css'

import { Field, FieldArray, Fields, FormSection, FormValueSelector } from '../../../../Common/forms'
import { ListingFieldConfig } from '../Shared/FieldConfig'
import {
  FormRow,
  When,
  HyperLink,
  RadioGroupInputField,
  CheckboxInputField,
  WrappedFlatpickrInputField,
  InputField,
  InputCountField,
  CheckboxMenuSelectField
} from '../../../../Common/Form'
import {
  getScopedShipTypeSectionName,
  getScopedFieldNameByShipType,
  hasIntersection,
  getProductNameLengthMax,
  getPriceCap
} from '../Shared/util'
import Tip from '../../Tip'

import {
  CONTENT_RATING_TYPES,
  GAME_CONTENT_TYPE_OPTIONS,
  RADIO_DEFAULT_TYPES,
  PRODUCT_DELIVERY_TYPE_OPTIONS,
  SHIP_TYPE_ERROR,
  RADIO_EVOUCHER_TYPES,
  EVOCHER_ATTRIBUTES_DATATYPES
} from '../../../../../constants/proposalTypes'
import {
  atLeast,
  normalizeSeoUrl,
  normalizeFeatureTitle,
  normalizeSeoUrlWithMaxLength
} from '../Shared/normalizers'
import {
  productSizeFieldsFormatter,
  minPackingCountFormatter
} from '../Shared/formatters'
import {
  validateMinPackingCount,
  validateCustomizedOrderShipDateAfterPlaced
} from '../Shared/validation/fieldLevelValidator'
import {
  skipRequiredThenValidate,
  validateFlow,
  preOrderExpectedShipDateValidation
} from '../Shared/validation/validations'
import SingleLineText from '../../ReadOnlyComponents/SingleLineText/SingleLineText'
import YPopover from '../../../../Common/Popover'
import { SHIP_TYPE_ID_FIELD_NAME } from '../../../../../lib/ReduxFormSelectors/ProposalListingForm'
import { productSizeFieldsParser } from '../../../../../lib/parser'
import { showOnlyNumber, showNoEmoji, formatAll } from '../../../../../lib/formatter'
import {
  isNewListingProposal,
  isNotPhaseOverview,
  isNewProductProposal
} from '../../../../../../lib/proposalHelper'
import {
  PRE_ORDER_EXPECTED_SHIP_DATE_OPTIONS,
  PRE_ORDER_EXPECTED_SHIP_DATE_SUPPLIER_OPTIONS,
  LISTING_IS_THRESHOLD_FREEBIE
} from '../../../Shared'
import { getDefaultListingOffShelvedTs } from '../../../../../lib/FormHelper'
import { IconPopoverLabel } from '../FormLabelTooltip/FormLabelTooltip'
import DatePickerField from './DatePickerField'
import ProductSizeFields from './ProductSizeFields/ProductSizeFields'
import { PopoverImg } from '@vzmi/shp_shared_compo'
import PreserveDays from './PreserveDays'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'

const { G, PG, PG12, PG15, R, NC18 } = PRODUCT_CONTENT_RATING
const CONTENT_RATINGS_FOR_GAME_SUB = [G, PG, PG12, PG15, R]
const CONTENT_RATINGS_FOR_SEX_TOY = [R, NC18]

// props check 不允許 Fragment 型態因此用 stateless comp 偽裝
const FragmentComponent = props => <Fragment {...props} />

class DeliveryTypeField extends PureComponent {
  render () {
    const { deliveryTypeOptions, readOnly, isNewProposal, mustShowFormError } = this.props

    return (
      <>
        <Field
          name='listing.deliveryType'
          data-role='listing-delivery-type'
          component={RadioGroupInputField}
          disabled={readOnly}
          buttonStyle='outline'
          options={deliveryTypeOptions}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      </>
    )
  }
}

// 因為是處於FormSection內的Field validation所以需要特別驗證
const preOrderExpectedShipDateValidator = validateFlow(skipRequiredThenValidate(required({ msg: '請輸入預定出貨日' })), preOrderExpectedShipDateValidation)

class DeliveryTypeAppendix extends PureComponent {
  render () {
    const { deliveryType, readOnly, phase, deliveryTypesFromUserProfile } = this.props
    const {
      PRE_ORDER,
      APPOINTMENT,
      CUSTOMIZED
    } = PRODUCT_DELIVERY_TYPE
    const isIncludedPreOrder = checkSuppilerIncludedPreOrder(deliveryTypesFromUserProfile)
    const preOrderOptions = isIncludedPreOrder ? PRE_ORDER_EXPECTED_SHIP_DATE_SUPPLIER_OPTIONS : PRE_ORDER_EXPECTED_SHIP_DATE_OPTIONS
    const preOrderPlaceholder = preOrderOptions.placeholder
    const preOrderExpectedShipDateFlatpickrOptions = isNotPhaseOverview(phase) ? preOrderOptions : {}
    switch (deliveryType) {
      case PRE_ORDER: {
        return (
          <FormRow>
            <div
              key='preOrderExpectedShipDateBlock'
              className={styles.preOrderExpectedShipDateBlock}
            >
              <span key='label'>預定出貨日：</span>
              <div key='field'>
                <Field
                  key='preOrderExpectedShipDate'
                  data-role='listing-pre-order-expected-ship-date'
                  name='listing.preOrderExpectedShipDate'
                  component={WrappedFlatpickrInputField}
                  readOnly={readOnly}
                  className={styles.preOrderExpectedShipDate}
                  enableCalender
                  validate={preOrderExpectedShipDateValidator}
                  placeholder={preOrderPlaceholder}
                  options={preOrderExpectedShipDateFlatpickrOptions}
                />
              </div>
            </div>
          </FormRow>
        )
      }
      case CUSTOMIZED: {
        return (
          <FormRow>
            <div
              key='customizedOrderShipDateAfterPlacedBlock'
              className={styles.customizedOrderShipDateAfterPlacedBlock}
            >
              <span key='customizdOrder'>
                收到訂單
              </span>
              <div key='field'>
                <Field
                  name='listing.customizedOrderShipDateAfterPlaced'
                  data-role='listing-customized-order-ship-date-after-placed'
                  className={styles.customizedOrderShipDateAfterPlaced}
                  component={InputField}
                  disabled={readOnly}
                  validate={validateCustomizedOrderShipDateAfterPlaced}
                  format={formatAll(
                    showOnlyNumber
                  )}
                  addonAfter='天'
                />
              </div>
              <span key='afterPlace'>後出貨</span>
            </div>
          </FormRow>
        )
      }
      case APPOINTMENT: {
        return (
          <FormRow>
            <span
              data-role='listing-appointment-message'
              style={{ marginLeft: '12px' }}
            >
              需與顧客約定送貨日
            </span>
          </FormRow>
        )
      }
      default:
        return null
    }
  }
}

/** 配送方式 hover 時的 popover */
const renderShipTypePopover = (shipTypeName, popoverContent) => (
  <YPopover content={popoverContent}>
    {shipTypeName}
  </YPopover>
)

// 商品材積上面的超商文案Tip
const ProductSizeWeightTip = ({ flags }) => {
  const isEndFami = getFeatureToggle(flags, 'sp_endFami')
  return (
    <>
      <FormRow key='productSizeTip'>
        <Tip type='info'>
          請參考超商材積標準
          <HyperLink
            className={styles.hyperLink}
            target='_blank'
            href='https://www.7-11.com.tw/service/accept.aspx'
          >
            7-11
          </HyperLink>
          {!isEndFami && (
            <HyperLink
              className={styles.hyperLink}
              target='_blank'
              href='https://www.famiport.com.tw/Web_Famiport/page/service_caption.aspx?MN=5&CN=1141'
            >
              全家
            </HyperLink>
          )}
        </Tip>
      </FormRow>
    </>
  )
}

/**
 * render 欄位： 商品材積, 商品重量 ，
 * 不同運送方式可以共用
 * */
const ProductSizeWeightSection = props => {
  const {
    productSizeKey,
    productWeightKey,
    readOnly,
    isTipExist,
    isNewProposal,
    mustShowFormError
  } = props
  return (
    <>
      <FormRow
        key={productSizeKey}
        className={(isTipExist === true) ? styles.resetMargin : null}
        label={(
          <IconPopoverLabel
            popoverContent={(
              <>
                請填寫包裝完成後的包裹材積，
                <br />
                而非商品本身，只接受正整數
              </>
            )}
          >
            商品材積
          </IconPopoverLabel>
        )}
      >
        <Fields
          names={[
            'setting._productSize',
            'product.length',
            'product.width',
            'product.height'
          ]}
          component={ProductSizeFields}
          readOnly={readOnly}
          format={productSizeFieldsFormatter}
          parse={productSizeFieldsParser}
          isNewProposal={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      </FormRow>
      <FormRow
        key={productWeightKey}
        label={(
          <IconPopoverLabel
            popoverContent={(
              <>
                請填寫包裝完成後的包裹重量，
                <br />
                而非商品本身，只接受正整數
              </>
            )}
          >
            商品重量
          </IconPopoverLabel>
        )}
      >
        <Field
          {...ListingFieldConfig.getField('product.weight')}
          component={readOnly ? SingleLineText : InputField}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      </FormRow>
    </>
  )
}

const getProductNameLengthConfig = (showExpiringAddon, proposalType) => {
  const lengthMax = getProductNameLengthMax(showExpiringAddon, proposalType)
  return {
    placeholder: `最多輸入${lengthMax}個字`,
    countLimit: lengthMax
  }
}

/** 是否顯示 (即期品) 在賣場名稱欄位最前面 */
const getShowExpiringAddon = (isExpiringItem, hasPreserveDays) => isExpiringItem && hasPreserveDays

const eVoucherValidate = isRequired => {
  return isRequired
    ? required()
    : () => {}
}

/**
 * 依照dataType render 相對應欄位，
 * OrderNumber 活動代碼, ProductCode 商品代碼, MerchantCode 品牌代碼
 * */
const EVoucherField = props => {
  const {
    fieldItem,
    readOnly,
    isNewProposal,
    mustShowFormError
  } = props
  const {
    dataType,
    isRequired,
    maxLength,
    name
  } = fieldItem

  const fieldName = `product.eVoucherAttributes.${name}`
  const dataRoleName = `product-eVoucherAttributes-${name}`
  const formRowDataRoleName = `product-formRow-eVoucherAttributes-${name}`
  let currentField = null
  switch (dataType) {
    case EVOCHER_ATTRIBUTES_DATATYPES.DATETIME: {
      currentField = (
        <Field
          data-role={dataRoleName}
          name={fieldName}
          component={DatePickerField}
          validate={eVoucherValidate(isRequired)}
          className={styles.dateField}
          readOnly={readOnly}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      )
      break
    }
    case EVOCHER_ATTRIBUTES_DATATYPES.INTEGER:
    case EVOCHER_ATTRIBUTES_DATATYPES.DECIMAL: {
      currentField = (
        <Field
          data-role={dataRoleName}
          name={fieldName}
          component={readOnly ? SingleLineText : InputCountField}
          validate={eVoucherValidate(isRequired)}
          className={styles.inputField}
          countLimit={maxLength}
          placeholder='請輸入數字'
          type='number'
          disabled={readOnly}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      )
      break
    }
    default: {
      currentField = (
        <Field
          data-role={dataRoleName}
          name={fieldName}
          component={readOnly ? SingleLineText : InputCountField}
          validate={eVoucherValidate(isRequired)}
          className={styles.inputField}
          countLimit={maxLength}
          disabled={readOnly}
          showErrorOnActive={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      )
      break
    }
  }

  return (
    <FormRow
      className={styles.eVoucherFieldFormRow}
      data-role={formRowDataRoleName}
      label={name}
      labelAlign='center'
    >
      {currentField}
    </FormRow>
  )
}

export class ProductInfo extends Component {
  constructor (props) {
    super(props)

    this.state = {
      shipTypeOptions: [],
      isGameSubStation: false,
      hasPreserveDays: false,
      gameContentTypeOptions: GAME_CONTENT_TYPE_OPTIONS,
      contentRatingOptions: CONTENT_RATING_TYPES
    }
  }

  componentDidMount () {
    const { currentSubStation } = this.props
    const formValues = _.get(this.props, 'formState.values', {})
    const shipType = _.get(formValues, SHIP_TYPE_ID_FIELD_NAME, '')
    this.syncContentRatingByGameStation(this.props, currentSubStation)
    this.syncShipTypeOptions(shipType, currentSubStation)
    this.syncHasPreserveDays()
  }

  componentDidUpdate (prevProps, prevState) {
    // sync the game content block when showGameContent changes
    const prevFormValues = _.get(prevProps, 'formState.values', {})
    const formValues = _.get(this.props, 'formState.values', {})
    if (_.get(formValues, 'setting.showGameContent') !== _.get(prevFormValues, 'setting.showGameContent')) {
      this.syncContentRatingByGameStation(this.props, this.props.currentSubStation)
    }

    const shipType = _.get(formValues, SHIP_TYPE_ID_FIELD_NAME, '')
    const productPreserveDaysField = getScopedFieldNameByShipType(shipType, 'product.preserveDays')
    const prevProductPreserveDays = _.get(prevFormValues, productPreserveDaysField)
    const productPreserveDays = _.get(formValues, productPreserveDaysField)
    if (!_.isNil(productPreserveDays) && !_.isEqual(prevProductPreserveDays, productPreserveDays)) {
      this.syncHasPreserveDays(this.props)
    }
  }

  componentWillReceiveProps (nextProps) {
    const { triggerFieldChange } = this.props
    const nextFormValues = _.get(nextProps, 'formState.values', {})
    const formValues = _.get(this.props, 'formState.values', {})
    const { subStationId, product = {} } = formValues
    const { gameContents } = product
    // 確保 shipTypeId 為數字在判斷時才不會有 string number 形態不同造成誤判
    const [shipType, nextShipType] = _.map(
      [
        _.get(formValues, SHIP_TYPE_ID_FIELD_NAME, ''),
        _.get(nextFormValues, SHIP_TYPE_ID_FIELD_NAME, '')
      ],
      Number
    )
    const nextSubStation = nextProps.currentSubStation
    const listingDeliveryTypeField = getScopedFieldNameByShipType(shipType, 'listing.deliveryType')
    const scopedDeliveryType = _.get(formValues, listingDeliveryTypeField)
    const nextScopedDeliveryType = _.get(nextFormValues, listingDeliveryTypeField)

    // 由於可能在複製賣場提案時copy到含有遊戲內容的賣場，但子站已非遊戲子站，必須移除軟體情節
    const { isVideoGame: isGameSubStation } = nextSubStation
    if (!isGameSubStation && gameContents) {
      this.removeGameContent()
    }
    const isSubstationChanged = subStationId !== _.get(nextFormValues, 'subStationId')
    if (isSubstationChanged) {
      this.syncContentRatingByGameStation(nextProps, nextSubStation)
      this.syncShipTypeOptions(nextShipType, nextSubStation)
    }

    if ((!nextShipType && subStationId)) {
      this.syncShipTypeOptions(nextShipType, nextSubStation)
    }

    switch (shipType) {
      case PRODUCT_SHIP_TYPE.EXPRESS_24HR: {
        // 交貨期限
        // 若為快速到貨且勾選需安裝，則交貨期為"客約送貨日"
        const nextFormValues = _.get(nextProps, 'formState.values', {})

        const isInstallRequiredFieldName = getScopedFieldNameByShipType(shipType, 'product.isInstallRequired')
        const scopedIsInstallRequired = _.get(formValues, isInstallRequiredFieldName)
        const nextScopedIsInstallRequired = _.get(nextFormValues, isInstallRequiredFieldName)
        if (scopedIsInstallRequired !== nextScopedIsInstallRequired) {
          this.syncDeliveryType(shipType, nextFormValues)
        }

        const nextIsExpiringItem = _.get(nextProps, 'isExpiringItem', false)
        const hasPreserveDays = _.get(this.state, 'hasPreserveDays', false)
        const nextShouldShowExpiringAddon = getShowExpiringAddon(nextIsExpiringItem, hasPreserveDays)
        const nextShowExpiringAddon = _.get(nextProps, 'showExpiringAddon', false)
        if (nextShowExpiringAddon !== nextShouldShowExpiringAddon) {
          triggerFieldChange('setting.showExpiringAddon', nextShouldShowExpiringAddon)
        }
        break
      }
      case PRODUCT_SHIP_TYPE.HOME_STORE: {
        const priceFieldName = 'listing.price'
        const nextFormValues = _.get(nextProps, 'formState.values', {})
        const price = _.get(nextFormValues, 'listing.price')
        const priceCap = getPriceCap(shipType, 'price')
        // 檢視模式時不應將售價調整成合法設定，應忠實呈現原資料內容
        if (!_.get(nextFormValues, 'setting.readOnly') && price > priceCap) {
          triggerFieldChange(priceFieldName, priceCap)
        }
        break
      }
      default: {
        break
      }
    }

    // comparing ship type to prevent loop calling issue
    if (shipType !== nextShipType || isSubstationChanged) {
      this.syncDeliveryType(shipType, nextFormValues)
    }

    // clean up when deliveryType changes
    if (nextScopedDeliveryType && scopedDeliveryType !== nextScopedDeliveryType) {
      switch (nextScopedDeliveryType) {
        case PRODUCT_DELIVERY_TYPE.PRE_ORDER: {
          const deliveryTypesFromUserProfile = _.get(nextProps, 'user.profile.toggles', [])
          const preOrderOptionsMinDate = checkSuppilerIncludedPreOrder(deliveryTypesFromUserProfile) ? PRE_ORDER_EXPECTED_SHIP_DATE_SUPPLIER_OPTIONS.minDate : PRE_ORDER_EXPECTED_SHIP_DATE_OPTIONS.minDate
          const preOrderExpectedShipDateField = getScopedFieldNameByShipType(shipType, 'listing.preOrderExpectedShipDate')
          triggerFieldChange(preOrderExpectedShipDateField, preOrderOptionsMinDate)
          break
        }
        default: {
          const preOrderExpectedShipDateField = getScopedFieldNameByShipType(shipType, 'listing.preOrderExpectedShipDate')
          const customizedOrderShipDateAfterPlacedField = getScopedFieldNameByShipType(shipType, 'listing.customizedOrderShipDateAfterPlaced')

          triggerFieldChange(preOrderExpectedShipDateField, null)
          triggerFieldChange(customizedOrderShipDateAfterPlacedField, null)
          break
        }
      }
    }
  }

  setShipTypeOptions = (shipTypeOptions) => {
    this.setState({ shipTypeOptions })
  }

  syncShipTypeOptions = (shipType, subStation) => {
    const { user, match, triggerFieldChange } = this.props
    const composeType = _.get(match, 'params.feature', '')
    const allowedShipTypes = getAllowedShipTypesBySubStationAndUser(subStation, user)
    const isNotAvailableStoreDeliverySubStation = _.includes(
      _.get(subStation, 'functions', []),
      SPECIAL_FUNCTION.NOT_AVAILABLE_STORE_DELIVERY
    )
    const UIShipTypeOptions = _.map(
      getUIShipTypeOptions(allowedShipTypes, composeType),
      option => {
        if (
          option.value === PRODUCT_SHIP_TYPE.HOME_STORE &&
          isNotAvailableStoreDeliverySubStation
        ) {
          return {
            ...option,
            disabled: true,
            tooltip: SHIP_TYPE_ERROR.NOT_AVAILABLE_STORE_DELIVERY
          }
        }
        return option
      }
    )
    const shipTypeOptionsWithPopover = UIShipTypeOptions.map(o => {
      const { label = '', tooltip = '', disabled = false } = o
      const omittedOption = _.omit(o, ['tooltip'])
      return disabled
        ? _.assign({}, omittedOption, { label: renderShipTypePopover(label, tooltip) })
        : omittedOption
    })

    const selectableShipTypeOptions = _.filter(shipTypeOptionsWithPopover, { disabled: false })
    const isValidShipType = _.find(selectableShipTypeOptions, { value: shipType })
    // 若有快速到貨則優先選取快速到貨
    const expressShipType = _.find(selectableShipTypeOptions, { value: PRODUCT_SHIP_TYPE.EXPRESS_24HR })
    const defaultShipType = expressShipType || _.get(selectableShipTypeOptions, '0', {})
    this.setShipTypeOptions(shipTypeOptionsWithPopover)
    const isOverview = _.get(this.props, 'match.params.phase') === PROPOSAL_PHASE_TYPE.OVERVIEW
    // 已經是檢視狀態則不需要再覆蓋原先表單設定的配送方式
    // 如果已選擇可以選的運送方式則不變欄位資料
    if (!isOverview && !isValidShipType) {
      triggerFieldChange(SHIP_TYPE_ID_FIELD_NAME, _.get(defaultShipType, 'value', null))
    }
  }

  syncDeliveryType = (shipType, formValues) => {
    const { triggerFieldChange } = this.props
    const listingDeliveryTypeField = getScopedFieldNameByShipType(shipType, 'listing.deliveryType')

    // 交貨期限:
    // 預設為正常交貨期
    // 若為快速到貨且勾選需安裝，則交貨期為"客約送貨日"
    const isExpress24HR = shipType === PRODUCT_SHIP_TYPE.EXPRESS_24HR
    if (isExpress24HR) {
      const productIsInstallRequiredField = getScopedFieldNameByShipType(shipType, 'product.isInstallRequired')
      const nextScopedIsInstallRequired = _.get(formValues, productIsInstallRequiredField)
      if (nextScopedIsInstallRequired) {
        triggerFieldChange(listingDeliveryTypeField, PRODUCT_DELIVERY_TYPE.APPOINTMENT)
      } else {
        triggerFieldChange(listingDeliveryTypeField, PRODUCT_DELIVERY_TYPE.NORMAL)
      }
    } else {
      triggerFieldChange(listingDeliveryTypeField, PRODUCT_DELIVERY_TYPE.NORMAL)
    }
  }

  handlePreserveDays = (e) => {
    const value = e.target.value
    const { triggerFieldChange } = this.props
    this.setState({
      hasPreserveDays: value
    })
    const shipType = _.get(this.props, 'formState.values.product.shipType.id')
    if (!value) {
      const resetFields = [
        'preserveDays',
        'years',
        'months',
        'days'
      ]
      for (const field of resetFields) {
        triggerFieldChange(getScopedFieldNameByShipType(shipType, `product.${field}`), null)
      }
    }
  }

  handleProductNameChange = (e, value) => {
    // When user changing productName, change seoUrl to the same value
    const { triggerFieldChange } = this.props
    const normalizedValue = normalizeSeoUrlWithMaxLength(FIELD_MAX_LENGTH.SEO_URL)(value)
    triggerFieldChange('listing.seoUrl', normalizedValue)
  }

  handleSeoUrlChange = (e, value) => {
    const { triggerFieldChange } = this.props
    const normalizedValue = normalizeSeoUrl(value)
    triggerFieldChange('setting.userSeoUrl', normalizedValue)
  }

  removeGameContent = () => {
    const { triggerFieldChange } = this.props
    triggerFieldChange('product.gameContents', null)
    triggerFieldChange('setting.showGameContent', false)
  }

  syncHasPreserveDays = (props = this.props) => {
    const formValues = _.get(props, 'formState.values', {})
    const shipType = _.get(formValues, SHIP_TYPE_ID_FIELD_NAME, '')
    if (
      shipType === PRODUCT_SHIP_TYPE.EXPRESS_24HR ||
      shipType === PRODUCT_SHIP_TYPE.E_VOUCHER
    ) {
      const productPreserveDaysField = getScopedFieldNameByShipType(shipType, 'product.preserveDays')
      const preserveDays = _.get(formValues, productPreserveDaysField, null)
      this.setState({
        hasPreserveDays: !_.isNil(preserveDays)
      })
    }
  }

  syncContentRatingByGameStation = (props, subStation) => {
    const { triggerFieldChange, formState } = props
    const { isVideoGame: isGameSubStation, isSexToy } = subStation
    const contentRating = _.get(formState, 'values.product.contentRating', null)
    const showGameContent = _.get(formState, 'values.setting.showGameContent', false)
    // 只有 `電玩` 子站，會出現 `輔導級15`
    let contentRatingOptions = _.filter(CONTENT_RATING_TYPES, (o) => o.value !== PRODUCT_CONTENT_RATING.PG15)
    // 若賣場子站或商品子站選擇：電玩 / 遊戲(28) 且遊戲軟體選項選擇"是"，則只顯示"普級"、"保護級"、"輔導級 12歲+"、"輔導級 15歲+"及"限制級"選項供選擇，此時不預設選項
    if (isGameSubStation && showGameContent) {
      contentRatingOptions = _.filter(CONTENT_RATING_TYPES, (o) => _.includes(CONTENT_RATINGS_FOR_GAME_SUB, o.value))
    } else if (isSexToy) {
      // 若賣場子站或商品子站選擇：情趣專區(566)，則只顯示"限制級"及"情趣商品"選項供選擇，此時不預設選項
      contentRatingOptions = _.filter(CONTENT_RATING_TYPES, (o) => _.includes(CONTENT_RATINGS_FOR_SEX_TOY, o.value))
    }

    this.setState(
      () => ({
        isGameSubStation,
        contentRatingOptions
      }),
      () => {
        const firstOptionVal = _.get(contentRatingOptions, '[0].value')
        if (isGameSubStation || isSexToy || !contentRating) {
          // 若賣場子站或商品子站選擇：電玩 / 遊戲(28) 且遊戲軟體選項選擇"是
          // 或者賣場子站或商品子站選擇：情趣專區(566)
          let localContentRating = ((isGameSubStation && showGameContent) || isSexToy) ? null : firstOptionVal
          if (_.includes(_.map(contentRatingOptions, 'value'), contentRating)) {
            localContentRating = contentRating
          }
          triggerFieldChange('product.contentRating', localContentRating)
          !showGameContent && triggerFieldChange('product.gameContents', null)
        } else if (!_.includes(_.map(contentRatingOptions, 'value'), contentRating)) {
          triggerFieldChange(
            'product.contentRating', firstOptionVal)
        }
      })
  }

  renderScopedShipTypeSection = shipType => {
    const {
      EXPRESS_24HR,
      HOME_STORE,
      E_VOUCHER
    } = PRODUCT_SHIP_TYPE

    switch (shipType) {
      case EXPRESS_24HR: {
        return this.renderShipType61Section()
      }
      case E_VOUCHER: {
        return this.renderShipType200150Section()
      }
      case HOME_STORE: {
        return this.renderShipType800Section()
      }
      default:
        return null
    }
  }

  /**
   *
   * 交貨期限選項
   * 若配送方式為 `快速到貨`或`電子票券`，則不顯示此選項
   * 若選擇其他配送方式（非快速到貨），但[提案子站]無提供"預購商品"&"訂製"&"客約"功能 (三個都沒有)，
   * 且[供應商特殊功能檔]無提供"預購商品"&"訂製"&"客約"功能 (三個都沒有)，
   * 則不顯示此選項，交貨期為正常交貨期
   * https://jira.vzbuilders.com/browse/APACSMDESK-55866
   *
   * normal: 正常交貨期
   * preOrder: 預購型商品
   * customized: 客製化商品
   * appointment: 客約送貨日
   */
  renderDeliveryTypeByShipType = () => {
    const {
      formState,
      readOnly,
      triggerFieldChange,
      currentSubStation,
      isNewProposal,
      mustShowFormError,
      user
    } = this.props
    const formValues = _.get(formState, 'values', {})
    const setting = _.get(formValues, 'setting', {})
    const shipType = _.get(formValues, SHIP_TYPE_ID_FIELD_NAME)
    const formSectionName = getScopedShipTypeSectionName({ shipType })
    const deliveryType = _.get(formValues, getScopedFieldNameByShipType(shipType, 'listing.deliveryType'), '')
    const { deliveryTypes: deliveryTypesFromSubStation = [] } = currentSubStation
    const deliveryTypesFromUserProfile = _.get(user, 'profile.toggles', [])

    let deliveryTypeOptions = []
    if (
      shipType === PRODUCT_SHIP_TYPE.EXPRESS_24HR ||
      shipType === PRODUCT_SHIP_TYPE.E_VOUCHER ||
      (
        !hasIntersection(deliveryTypesFromSubStation) &&
        !hasIntersection(deliveryTypesFromUserProfile)
      )
    ) {
      return null
    }
    // 若提案子站有提供"客約"功能且配送方式非直店配，則顯示客約送貨日
    // 故若是直店配則刪除客約送貨日
    deliveryTypeOptions = _.filter(PRODUCT_DELIVERY_TYPE_OPTIONS, (o) => {
      const value = o.value
      if (value === PRODUCT_DELIVERY_TYPE.APPOINTMENT && shipType === PRODUCT_SHIP_TYPE.HOME_STORE) {
        return null
      }
      const deliveryTypes = _.uniq([
        // 非快速到貨預設一定有正常交貨期
        PRODUCT_DELIVERY_TYPE.NORMAL,
        ...deliveryTypesFromSubStation,
        ...deliveryTypesFromUserProfile
      ])
      return _.includes(deliveryTypes, value)
    })

    return (
      <FormSection
        name={formSectionName}
        component={FragmentComponent}
      >
        <FormRow
          labelAlign='top'
          label='交貨期限'
        >
          <DeliveryTypeField
            readOnly={readOnly}
            triggerFieldChange={triggerFieldChange}
            deliveryType={deliveryType}
            deliveryTypeOptions={deliveryTypeOptions}
            formSectionName={formSectionName}
            isNewProposal={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <DeliveryTypeAppendix
          readOnly={readOnly}
          deliveryType={deliveryType}
          phase={setting.phase}
          deliveryTypesFromUserProfile={deliveryTypesFromUserProfile}
        />
      </FormSection>
    )
  }

  // 快速到貨
  renderShipType61Section = () => {
    const {
      proposalType,
      formState,
      readOnly,
      isNewProposal,
      mustShowFormError
    } = this.props
    const { hasPreserveDays } = this.state
    const formSectionName = getScopedShipTypeSectionName({ shipType: PRODUCT_SHIP_TYPE.EXPRESS_24HR })
    const formValues = _.get(formState, 'values', {})
    const { setting = {} } = formValues
    const { applianceContract, outrightPurchaseContract } = setting

    return (
      <FormSection
        name={formSectionName}
        component={FragmentComponent}
      >
        <When
          value={applianceContract}
          isTrue
        >
          <FormRow
            label='大型商品設定'
            subTitle='(非必填)'
          >
            <div
              key='group'
              className={styles.largeVolumeCheckboxGroup}
            >
              <Field
                label='需安裝'
                key='isInstallRequired'
                name='product.isInstallRequired'
                data-role='product-is-install-required'
                className={styles.isInstallRequired}
                component={CheckboxInputField}
                readOnly={readOnly}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
              {/* 一般賣場提案 */}
              <When
                value={isNewProductProposal(proposalType)}
                isFalse
              >
                <div className={styles.installTips}>
                  <p>(1) 需安裝or廢四機勾選其一，即屬客約商品，由東源配送/安裝。</p>
                  <p>(2) 需由東源配送但不需安裝賣場，請勾選廢四機即可(不需勾選需安裝)。</p>
                </div>
              </When>
              {/* 贈品/加價購/屬性商品提案 */}
              <When
                value={isNewProductProposal(proposalType)}
                isTrue
              >
                <div className={styles.installTips}>
                  <p>(1) 需安裝or廢四機只要勾選其一，即屬客約商品，由東源配送/安裝。</p>
                  <p>(2) 贈品、配件不需勾需安裝or廢四機。</p>
                  <p>(3) 例外：分離式冷氣室外機要勾需安裝(不勾廢四機)。</p>
                </div>
                <Field
                  label='附屬贈品(東源家電附屬贈品，請務必勾選確保入對應倉)'
                  key='isLargeVolumnProductGift'
                  name='product.isLargeVolumnProductGift'
                  data-role='product-is-large-volumn-product-gift'
                  className={classNames(styles.isLargeVolumnProductGift, 'hidden')}
                  component={CheckboxInputField}
                  readOnly={readOnly}
                  showErrorOnActive={isNewProposal}
                  mustShowFormError={mustShowFormError}
                />
              </When>
            </div>
          </FormRow>
        </When>
        {/** isTipExist判斷有沒有顯示超取的Tip */}
        <ProductSizeWeightSection
          isTipExist={false}
          readOnly={readOnly}
          productSizeKey='shipType61ProductSize'
          productWeightKey='shipType61ProductWeight'
          isNewProposal={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
        <PreserveDays
          label={(
            <IconPopoverLabel
              popoverContent={(
                <>
                  <p className={styles.preserveDaysTips}>
                    保存期限可填 18個月 或 1年6個月 或 540天
                  </p>
                  <PopoverImg
                    url={`${CDN}/supplier/preserve-days-sample-v2.png`}
                    width={481}
                    height={205}
                  />
                </>
              )}
            >
              保存期限
            </IconPopoverLabel>
          )}
          tip={(
            <Tip
              key='info'
              type='info'
              className={styles.fullWidth}
            >
              請依商品保存期限填寫，如填寫不符，將無法順利入倉
              <br />
              範例：請參考圖示說明
            </Tip>
          )}
          shipTypeId={PRODUCT_SHIP_TYPE.EXPRESS_24HR}
          hasPreserveDays={hasPreserveDays}
          readOnly={readOnly}
          isNewProposal={isNewProposal}
          mustShowFormError={mustShowFormError}
          handlePreserveDays={this.handlePreserveDays}
        />
        <When
          key='shipType610ProductIsExpiringItem'
          value={hasPreserveDays}
          isTrue
        >
          <FormRow label='即期品' >
            <Tip
              key='label'
              className={styles.contentLabel}
              type='label'
            >
              商品是否為即期品
            </Tip>
            <Field
              key='isExpiringItem'
              name='product.isExpiringItem'
              data-role='product-is-expiring-item'
              className={styles.isExpiringItem}
              component={RadioGroupInputField}
              disabled={readOnly}
              buttonStyle='outline'
              options={RADIO_DEFAULT_TYPES}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
        </When>
        {outrightPurchaseContract && (
          <FormRow
            key='shipType200ProductIsOutrightPurchase'
            label='買斷商品'
          >
            <Tip
              key='label'
              className={styles.contentLabel}
              type='label'
            >
              商品是否為買斷商品
            </Tip>
            <Field
              key='isOutrightPurchase'
              name='product.isOutrightPurchase'
              data-role='product-is-outright-purchase'
              className={styles.isOutrightPurchase}
              component={RadioGroupInputField}
              disabled={readOnly}
              buttonStyle='outline'
              options={RADIO_DEFAULT_TYPES}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
        )}
        <FormRow
          key='shipType61ProductMinPackingCount'
          label={(
            <IconPopoverLabel
              popoverContent='進倉時，自動補貨單建議的最小數量'
            >
              最小包裝數
            </IconPopoverLabel>
          )}
        >
          <Field
            name='product.minPackingCount'
            type='text'
            data-role='product-min-packing-count'
            className={styles.minPackingCount}
            component={
              readOnly
                ? SingleLineText
                : InputField
            }
            onChange={this.handleMinPacking}
            validate={validateMinPackingCount}
            format={minPackingCountFormatter}
            normalizeOnBlur={atLeast(1)}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
      </FormSection>
    )
  }

  // 電子票券
  renderShipType200150Section = () => {
    const {
      user,
      readOnly,
      isNewProposal,
      mustShowFormError
    } = this.props
    const { hasPreserveDays } = this.state
    const formSectionName = getScopedShipTypeSectionName({ shipType: PRODUCT_SHIP_TYPE.E_VOUCHER })
    const eVoucherFieldFromUser = _.get(user, 'eVoucherAttributes', [])
    return (
      <FormSection
        name={formSectionName}
        component={FragmentComponent}
      >
        <PreserveDays
          shipTypeId={PRODUCT_SHIP_TYPE.E_VOUCHER}
          hasPreserveDays={hasPreserveDays}
          readOnly={readOnly}
          isNewProposal={isNewProposal}
          mustShowFormError={mustShowFormError}
          handlePreserveDays={this.handlePreserveDays}
        />
        <FormRow
          key='shipType200150eVoucherType'
          data-role='eVoucherType-formRow'
          label='票券類型'
          labelAlign='top'
        >
          <Field
            key='eVoucherType'
            name='product.eVoucherType'
            data-role='eVoucherType-radio'
            className={styles.eVoucherType}
            component={RadioGroupInputField}
            disabled={readOnly}
            buttonStyle='outline'
            options={RADIO_EVOUCHER_TYPES}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <FormRow
          data-role='eVoucherField-formRow'
          noLabel
        >
          {eVoucherFieldFromUser.map((fieldItem, index) => {
            return (
              <EVoucherField
                key={index}
                fieldItem={fieldItem}
                readOnly={readOnly}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
            )
          })}
        </FormRow>
      </FormSection>
    )
  }

  // 直店配
  renderShipType800Section = () => {
    const { readOnly, isNewProposal, mustShowFormError, flags } = this.props
    const formSectionName = getScopedShipTypeSectionName({ shipType: PRODUCT_SHIP_TYPE.HOME_STORE })
    return (
      <FormSection
        name={formSectionName}
        component={FragmentComponent}
      >
        <ProductSizeWeightTip flags={flags} />
        <ProductSizeWeightSection
          isTipExist
          readOnly={readOnly}
          productSizeKey='shipType800ProductSize'
          productWeightKey='shipType800ProductWeight'
          isNewProposal={isNewProposal}
          mustShowFormError={mustShowFormError}
        />
      </FormSection>
    )
  }

  syncListingOffShelvedTs = (e, value) => {
    const { triggerFieldChange } = this.props
    triggerFieldChange('listing.offShelvedTs', getDefaultListingOffShelvedTs(value))
  }

  // 只限選擇電子票券，滿額贈贈品選項只能為「否」
  handleShipTypeChange = (e, value) => {
    const { triggerFieldChange } = this.props
    const isShipTypeIsEVoucher = value === PRODUCT_SHIP_TYPE.E_VOUCHER
    if (isShipTypeIsEVoucher) {
      triggerFieldChange('listing.isThresholdFreebie', false)
    }
    // 當 clone 或複製電子票券賣場時， 在切換配送方式須清空 product.shipType.model ，避免配送方式有誤，無法完成提案
    if (value !== PRODUCT_SHIP_TYPE.E_VOUCHER) {
      const shipType = {
        id: value
      }
      triggerFieldChange('product.shipType', shipType)
    }
  }

  render () {
    const {
      shipTypeOptions,
      isGameSubStation,
      gameContentTypeOptions,
      contentRatingOptions
    } = this.state

    const {
      readOnly,
      triggerFieldChange,
      showExpiringAddon,
      proposalType,
      isNewProposal,
      mustShowFormError
    } = this.props

    const formValues = _.get(this.props, 'formState.values', {})
    const {
      listing = {},
      product = {},
      setting = {}
    } = formValues

    const onShelvedTs = _.get(listing, 'onShelvedTs', '')
    const shipType = _.get(product, 'shipType.id', '')
    const identity = _.get(setting, 'user.identity', {})
    const isThresholdFreebie = _.get(formValues, LISTING_IS_THRESHOLD_FREEBIE)
    const { recycleApplianceToggle, applianceContract } = setting

    const productNameLengthConfig = getProductNameLengthConfig(showExpiringAddon, proposalType)
    const isNewListing = isNewListingProposal(proposalType)
    const isNeedRecycleVisible = (
      recycleApplianceToggle &&
      (
        // 配送方式非快速到貨 或 快速到貨 + 有簽署家電增補附約才顯示廢四機
        // https://jira.vzbuilders.com/browse/APACSMDESK-46722
        (shipType !== PRODUCT_SHIP_TYPE.EXPRESS_24HR) ||
        (
          (shipType === PRODUCT_SHIP_TYPE.EXPRESS_24HR) &&
          applianceContract
        )
      )
    )

    return (
      <div
        className={styles.ProductInfo}
        data-role='mall-info'
      >
        <When
          value={!readOnly}
          isTrue
        >
          <FormRow
            key='productNameTip'
          >
            <Tip type='info'>
              內容順序建議：品牌、商品名、型號、關鍵規格、組合數量(非必要)、促銷字 (非必要，如福利品/限定款)。
              <br />
              請妥善運用前28個字，可增加SEO流量，細節請參考
              <HyperLink
                target='_blank'
                href='https://docs.google.com/presentation/d/1EMDnUOHTjurkR5CoYnt0B_qgsRWvQobKAYHjgoUzKsk/edit#slide=id.gc6f9544c1_0_0'
              >
                SEO優化詳細說明
              </HyperLink>
              。
            </Tip>
          </FormRow>
        </When>
        <FormRow
          key='productName'
          className={styles.resetMargin}
          label={isNewListing ? '賣場名稱' : '商品名稱'}
          withInputCountPaddingBottom
        >
          {/* changed product.name triggers listing.seoUrl changes in `reduxForm(config) onChange`  */}
          <Field
            {...ListingFieldConfig.getField('product.name')}
            component={readOnly ? SingleLineText : InputCountField}
            addonBefore={showExpiringAddon ? EXPIRING_NOTE.STR : ''}
            fullWidth
            onChange={this.handleProductNameChange}
            {...productNameLengthConfig}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <When
          value={isNewListing}
          isTrue
        >
          <When
            value={!readOnly}
            isTrue
          >
            <FormRow
              key='listingSeoUrlTip'
            >
              <Tip type='info'>
                不可使用特殊符號與空格。賣場產生後無法修改，請謹慎填寫。
              </Tip>
            </FormRow>
          </When>
          <FormRow
            key='listingSeoUrl'
            className={styles.resetMargin}
            label='中文化網址'
            withInputCountPaddingBottom={!readOnly}
          >
            <Field
              {...ListingFieldConfig.getField('listing.seoUrl')}
              component={readOnly ? SingleLineText : InputCountField}
              onChange={this.handleSeoUrlChange}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
          <When
            value={!readOnly}
            isTrue
          >
            <FormRow>
              <Tip type='info'>
                建議填寫，放入重點關鍵字、相關字、同義字或促銷文字，提示用戶商品優勢。
              </Tip>
            </FormRow>
          </When>
          <FormRow
            className={styles.resetMargin}
            withInputCountPaddingBottom
            subTitle='(非必填)'
            label={(
              <IconPopoverLabel
                popoverContent={(
                  <PopoverImg
                    url={`${CDN}/img/tooltip_subtitle.png`}
                    width={500}
                    height={290}
                  />
                )}
              >
                特色標題
              </IconPopoverLabel>
            )}
          >
            <Field
              name='listing.featureTitle'
              data-role='listing-feature-title'
              className={styles.advanceInput}
              component={readOnly ? SingleLineText : InputCountField}
              type='text'
              countLimit={20}
              placeholder='最多20個字元，為求APP呈現最佳化，建議12字以內最佳'
              normalizeOnBlur={normalizeFeatureTitle}
              format={showNoEmoji}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
        </When>
        <FormRow
          key='shortDescription'
          label={(
            <IconPopoverLabel
              popoverContent={(
                <PopoverImg
                  url={`${CDN}/img/tooltip_feature.png`}
                  width={600}
                  height={322}
                />
              )}
            >
              商品特色
            </IconPopoverLabel>
          )}
          withInputCountPaddingBottom
          labelAlign='top'
        >
          <FieldArray
            {...ListingFieldConfig.getField('product.shortDescription')}
            readOnly={readOnly}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <When
          value={isNewListing}
          isTrue
        >
          <FormRow
            key='listingOnShelvedTsDate'
            label='開始時間'
          >
            <Field
              data-role='listing-on-shelved-date'
              name='listing.onShelvedTs'
              triggerFieldChange={triggerFieldChange}
              component={DatePickerField}
              readOnly={readOnly}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />

          </FormRow>
          <FormRow
            key='listingOffShelvedTsDate'
            label='結束時間'
            className={styles.endDateTime}
          >
            <Field
              data-role='listing-off-shelved-date'
              name='listing.offShelvedTs'
              component={DatePickerField}
              readOnly={readOnly}
              onShelvedTs={onShelvedTs}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
            <span className={styles.timeTip}>
              超過結束時間，賣場頁仍將存在並顯示”已停售”。若需移除賣場，請至賣場上/下架功能申請『永久停售』
            </span>
          </FormRow>

        </When>
        {isGameSubStation && (
          <FormRow
            key='gameContentRadio'
            label='遊戲軟體'
          >
            <Tip
              className={styles.contentLabel}
              type='label'
            >
              商品是否為遊戲軟體
            </Tip>
            <Field
              className={styles.gameContentRadio}
              name='setting.showGameContent'
              data-role='game-content-radio'
              component={RadioGroupInputField}
              buttonStyle='outline'
              options={RADIO_DEFAULT_TYPES}
              disabled={readOnly}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
        )}
        <FormValueSelector fieldName='setting.showGameContent'>
          {showGameContent => isGameSubStation && showGameContent && (
            <FormRow
              key='gameContent'
              label={(
                <IconPopoverLabel
                  popoverContent='配合法規，遊戲軟體須標示情節內容'
                >
                  軟體情節
                </IconPopoverLabel>
              )}
            >
              <Field
                key='gameContents'
                {...ListingFieldConfig.getField('product.gameContents')}
                options={gameContentTypeOptions}
                component={readOnly ? SingleLineText : CheckboxMenuSelectField}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
            </FormRow>
          )}
        </FormValueSelector>
        {/* 賣場, 商品級別 */}
        <FormRow
          label={(
            <IconPopoverLabel
              popoverContent='若為未滿18歲青少年不能購買之商品，請選擇限制級'
            >
              {`${isNewListing ? '賣場' : '商品'}級別`}
            </IconPopoverLabel>
          )}
          labelAlign='top'
        >
          <Field
            key='productContentRating'
            {...ListingFieldConfig.getField('product.contentRating')}
            options={contentRatingOptions}
            disabled={readOnly}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        {/* 配送方式 */}
        <FormRow
          key='productShipType'
          label='配送方式'
          labelAlign='top'
        >
          <Field
            {...ListingFieldConfig.getField(SHIP_TYPE_ID_FIELD_NAME)}
            className={styles.productShipType}
            options={shipTypeOptions}
            disabled={readOnly}
            onChange={this.handleShipTypeChange}
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        {/* 廢四機商品 */}
        <When
          value={isNeedRecycleVisible}
          isTrue
        >
          <FormRow key='expiredTsTip'>
            <Tip type='info'>
              {IS_NEED_RECYCLE_TEXT}
            </Tip>
          </FormRow>
          <FormRow
            className={styles.isNeedRecycleFormRow}
            label='廢四機商品'
            subTitle='(非必填)'
            labelAlign='top'
          >
            <Field
              name='product.isNeedRecycle'
              data-role='product-is-need-recycle'
              component={RadioGroupInputField}
              disabled={readOnly}
              options={RADIO_DEFAULT_TYPES}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
        </When>
        {/*  交貨期限選項 */}
        {isNewListing && this.renderDeliveryTypeByShipType()}
        {/* 快速到貨, 電子票券, 直店配, 商品尺寸之類的設定 */}
        {this.renderScopedShipTypeSection(shipType)}
        {/* 僅 PM 登入，才顯示此欄位 （非PM，則此欄位預設為 false） */}
        <When
          value={isNewListing && identity.isPM}
          isTrue
        >
          <FormRow
            key='listingIsDisplayer'
            label='顯示設定'
          >
            <Tip
              className={styles.contentLabel}
              type='label'
            >
              是否顯示此賣場
            </Tip>
            <Field
              name='listing.isDisplay'
              data-role='listing-is-display'
              className={styles.isDisplay}
              component={RadioGroupInputField}
              disabled={readOnly || isThresholdFreebie}
              buttonStyle='outline'
              options={[
                { label: '顯示', value: true },
                { label: '不顯示', value: false }
              ]}
              showErrorOnActive={isNewProposal}
              mustShowFormError={mustShowFormError}
            />
          </FormRow>
          {
            isThresholdFreebie && (
              <FormRow withTopTip>
                <Tip type='important'>當為「滿額贈活動贈品」時，僅能選擇不顯示</Tip>
              </FormRow>
            )}
        </When>

      </div>
    )
  }
}

ProductInfo.propTypes = {
  proposalType: PropTypes.string.isRequired,
  currentSubStation: PropTypes.object.isRequired,
  formState: PropTypes.object,
  isExpiringItem: PropTypes.bool,
  match: PropTypes.object,
  readOnly: PropTypes.bool,
  triggerFieldChange: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

export default ProductInfo
